var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"buttons"},[_c('span',{staticClass:"button is-info is-small",attrs:{"disabled":_vm.isCounted},on:{"click":_vm.startCount}},[_vm._v("Recount")]),_c('span',{staticClass:"button is-warning is-small",attrs:{"disabled":_vm.isAudited},on:{"click":_vm.startAudit}},[_vm._v("Audit")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }